export default __webpack_public_path__ + "static/media/kodukant_logo.c81a5fee.png";